import { AgentService } from '@/services';
import { AgentType, PaginationType, RootModel } from '@/types';
import { createModel } from '@rematch/core';
import baseEntity from './base.entity';

interface AgentStateType {
  ids: { [id: number]: AgentType };
}

export const agentEntities = createModel<RootModel>()({
  state: { ids: {} } as AgentStateType,
  reducers: {
    ...baseEntity,
  },
  effects: () => ({
    async load(payload): Promise<{ content: AgentType[] } & PaginationType> {
      const res = await AgentService.filter(payload);
      const { content } = res.data;
      if (content && content.length) {
        this.saveSimplified(content);
      }
      return res.data;
    },
    async findById(payload, state: any): Promise<AgentType> {
      const item = state.showroomEntities.ids[payload];
      if (item && !item.simplified) {
        return item;
      }
      const res = await AgentService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await AgentService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await AgentService.create(payload));
      } else {
        ({ data: item } = await AgentService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
    async publish(payload) {
      const { data } = await AgentService.publish(payload);
      this.update(data);
      return data;
    },
  }),
});
